/**
 * Cache API en mémoire (session). Pas de localStorage : les soldes et
 * opérations ne doivent pas rester en clair sur le disque.
 */

const store = new Map()
const CACHE_DURATION = 5 * 60 * 1000

function getCacheKey(url, params = {}) {
  return `${url}_${JSON.stringify(params)}`
}

function purgeLegacyLocalStorageCache() {
  try {
    const keys = Object.keys(localStorage)
    keys.forEach((key) => {
      if (key.startsWith('api_cache_')) localStorage.removeItem(key)
    })
  } catch {
    // Mode privé / stockage désactivé
  }
}

export function getCachedData(url, params = {}) {
  const key = getCacheKey(url, params)
  const cached = store.get(key)
  if (!cached) return null
  if (Date.now() - cached.timestamp > cached.duration) {
    store.delete(key)
    return null
  }
  return cached.data
}

export function setCachedData(url, params = {}, data, duration = CACHE_DURATION) {
  store.set(getCacheKey(url, params), {
    data,
    timestamp: Date.now(),
    duration,
  })
}

export function invalidateCache(url, params = null) {
  if (params !== null) {
    store.delete(getCacheKey(url, params))
    return
  }
  for (const key of [...store.keys()]) {
    if (key.startsWith(`${url}_`) || key.startsWith(url)) {
      store.delete(key)
    }
  }
}

export function clearOldCache() {
  const now = Date.now()
  for (const [key, cached] of store) {
    if (now - cached.timestamp > cached.duration) store.delete(key)
  }
}

export function clearAllCache() {
  store.clear()
}

if (typeof window !== 'undefined') {
  purgeLegacyLocalStorageCache()
  clearOldCache()
  setInterval(clearOldCache, 10 * 60 * 1000)
}
